
module.exports = {
  // TODO: change your profile information here
  name: "Muskan Jain",
  greeting: "Hey 👋",
  greetingDescription: "I'm Muskan Jain and I'm an aspiring software engineer!",
  githubUrl: "https://github.com/muskanapp",
  linkedinUrl: "https://www.linkedin.com/in/muskan--jain",
  cvLink: "https://drive.google.com/file/d/1kSv4GPwAVrri14DIDo7GC3jybdpoTXTS/view",
};
